
 function accordionsInit() {
  const accordions = document.querySelectorAll('[data-accordion]');

  if (accordions == null) {
    return;
  }

  accordions.forEach(accordion => {
    const accordionToggle = accordion.querySelector('[data-accordion-title]');
    const accordionToggleIcon = accordion.querySelector('[data-accordion-title-icon]');
    const accordionContent = accordion.querySelector('[data-accordion-content]');
    accordionToggle.addEventListener('click', (event) => {
      event.preventDefault();

      accordion.classList.toggle('is-active');
      if (accordion.classList.contains('is-active')) {
        accordionContent.style.maxHeight = `${accordionContent.scrollHeight}px`;
        accordionToggleIcon.textContent = '-';
        setTimeout(() => {
          accordionContent.removeAttribute('style');
          accordionContent.classList.add('is-open');
        }, 500);
      } else {
        accordionContent.removeAttribute('style');
        accordionContent.classList.remove('is-open');
        accordionToggleIcon.textContent = '+';
      }
    });
  });
}


// Check if Yotpo is initialized
function yotpoSliderInit() {
  const reviewsWrapper = document.querySelector('[data-product-reviews]');
  const productReviews = document.querySelector('[data-product-template-reviews]');
  let mySwiper = null;
  const isProductTemplate = (productReviews !== null);

  const yotpoLoaded = setInterval(() => {
    const yotpoWrapper = document.querySelector('.main-widget');
    // If no reviews, add class and bail
    if (yotpoWrapper != null && yotpoWrapper.classList.contains('yotpo-no-reviews')) {
      reviewsWrapper.classList.add('no-reviews');
      clearInterval(yotpoLoaded);
      return;
    }

    // If reviews, make swiper, add click listener
    const yotpoReview = document.querySelector('.yotpo-review');
    if (yotpoReview !== null) {
      rejigLayout();
      rejigReviews();
      mySwiper = makeSwiper();
      disableSwiperOnDesktop();
      reviewLoadedChecker();
      clearInterval(yotpoLoaded);
    }
  }, 100);

  // Cancel interval if no reviews after 10 seconds
  setTimeout(() => {
    clearInterval(yotpoLoaded);
  }, 10000);

  function makeSwiper() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    const sliderContainer = document.createElement('div');
    sliderContainer.classList.add('swiper-container', 'reviews-slider');
    sliderContainer.setAttribute('data-product-reviews-swiper-container', '');
    const sliderWrapper = document.createElement('div');
    sliderWrapper.classList.add('swiper-wrapper');
    sliderContainer.prepend(sliderWrapper);
    yotpoReviews.prepend(sliderContainer);

    initSwiper(sliderContainer);

    const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    if (yotpoReviewsList !== null) {
      const yotpoReviewArrays = [...yotpoReviewsList];
      yotpoReviewArrays.forEach((review) => {
        review.classList.add('swiper-slide');
        mySwiper.appendSlide(review);
      });
    }
    return mySwiper;
  }

  function initSwiper(sliderContainer) {
    const options = {
      slidesPerView: 'auto',
      centeredSlides: false,
      freeMode: true,
      loop: false,
      mousewheel: {
        forceToAxis: true,
        eventsTarget: '.reviews-slider',
        invert: true,
      },
      navigation: {
        nextEl: '.swiper-nav__btn--next',
        prevEl: '.swiper-nav__btn--prev',
      },
    };

    mySwiper = new Swiper(sliderContainer, options);
  }

  function rejigLayout() {
    const bottomLine = reviewsWrapper.querySelector('.yotpo-bottomline');
    const yotopLabel = reviewsWrapper.querySelector('.yotpo-label');
    const yotopLabelClear = yotopLabel.querySelector('.yotpo-clr');
    const writeReviewButton = reviewsWrapper.querySelector('.write-review-button');
    const bottomLineEls = document.querySelectorAll('[data-yotpo-bottomline-container]');

    if (bottomLine == null) { return; }
    bottomLine.classList.remove('pull-left');
    writeReviewButton.classList.remove('pull-right');
    yotopLabelClear.remove();
    yotopLabel.appendChild(bottomLine);
    yotopLabel.appendChild(writeReviewButton);

    if (bottomLineEls == null) { return; }
    const bottomLineClone = bottomLine.cloneNode(true);
    bottomLineEls.forEach(bottomLineEl => {
      bottomLineEl.append(bottomLineClone);
    });
  }

  function rejigReviews() {
    const yotpoReviewsList = document.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
    yotpoReviewsList.forEach(review => {
      const reviewHeader = review.querySelector('.yotpo-header');
      const reviewFooter = review.querySelector('.yotpo-footer');
      const reviewStars = review.querySelector('.yotpo-review-stars');
      const reviewStarsClone = reviewStars.cloneNode(true);
      const reviewName = review.querySelector('.yotpo-user-name');
      const reviewNameClone = reviewName.cloneNode(true);
      const reviewVerified = reviewHeader.querySelector('.label-with-tooltip');
      const reviewhelpfulLabel = review.querySelector('.label-helpful');

      if (reviewVerified !== null) {
        const reviewVerifiedClone = reviewVerified.cloneNode(true);
        reviewVerifiedClone.classList.add('verified-buyer');
        reviewFooter.prepend(reviewVerifiedClone);
        reviewVerified.remove();
      }
      reviewHeader.appendChild(reviewStarsClone);
      reviewFooter.prepend(reviewNameClone);

      reviewhelpfulLabel.innerText = 'Was This Helpful?';

      // Cleanup
      reviewName.remove();
      reviewStars.remove();
    });
  }

  function reviewLoadedChecker() {
    const yotpoReviews = document.querySelector('.yotpo-reviews');
    document.querySelectorAll('.yotpo-page-element').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (trigger.classList.contains('yotpo-disabled')) {
          return;
        }
        yotpoReviews.style.visibility = 'hidden';
        const checkReviewsLoading = setInterval(() => {
          const yotpoReviewsList = yotpoReviews.querySelectorAll('.yotpo-review:not(.yotpo-hidden)');
          if (yotpoReviewsList != null && yotpoReviewsList.length > 0 && !yotpoReviewsList[0].classList.contains('swiper-slide')) {
            rejigReviews();
            mySwiper = makeSwiper();
            disableSwiperOnDesktop();
            yotpoReviews.style.visibility = 'visible';
            clearInterval(checkReviewsLoading);
            reviewLoadedChecker();
          }
        }, 50);
      });
    });
  }

  const breakpoint = window.matchMedia('(min-width: 750px)');
  breakpoint.addListener(disableSwiperOnDesktop);

  function disableSwiperOnDesktop() {
    if (!isProductTemplate) { return; }
    const swiperContainer = document.querySelector('[data-product-reviews-swiper-container]');
    if (swiperContainer === null) { return; }

    if (breakpoint.matches === true) {
      if (mySwiper !== null && typeof mySwiper !== 'undefined') {
        swiperContainer.classList.add('destroyed');
        mySwiper.destroy(true, true);
        mySwiper = null;
      }
    } else {
      initSwiper(swiperContainer);
      swiperContainer.classList.remove('destroyed');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  yotpoSliderInit();
});


// gallery slider


function customProductGallery() {
  const siteBody = document.querySelector('[data-site-body]');
  const customizerButton = document.querySelector('[data-mobile-product-customizer-toggle]');
  const galleryWraps = document.querySelectorAll('[data-product-custom-gallery-wrap]');
  if (!galleryWraps) { return; }

  galleryWraps.forEach(galleryWrap => {
    const gallery = galleryWrap.querySelector('[data-product-custom-gallery]');
    if (!gallery) { return; }

    const content = galleryWrap.querySelector('[data-product-custom-gallery-content]');
    const galleryImageWrap = galleryWrap.querySelector('[data-product-custom-gallery-images]');
    const galleryImages = galleryImageWrap.querySelectorAll('[data-product-custom-image]');
    const galleryThumbsWrap = galleryWrap.querySelector('[data-product-custom-gallery-thumbs]');
    const galleryThumbs = galleryThumbsWrap.querySelectorAll('[data-product-custom-thumb]');
    const galleryActivateThumbs = galleryWrap.querySelector('[data-product-custom-thumbs]');
    const mobileGalleryOpenButton = galleryWrap.querySelector('[data-product-custom-gallery-mobile-toggle]');
    const closeButton = galleryWrap.querySelector('[data-product-custom-gallery-close]');
    const ctaButton = galleryWrap.querySelector('[data-product-custom-gallery-cta]');
    let lastScrollPos = null;
    let galleryControls = null;
    const galleryControlsWrapper = galleryWrap.querySelector('[data-product-custom-gallery-controls]');
    const galleryMore = galleryWrap.querySelector('[data-product-custom-gallery-more]');

    if (galleryControlsWrapper) {
      galleryControls = galleryControlsWrapper.querySelectorAll('[data-product-custom-gallery-control]');
    }

    if (!galleryImages || !galleryThumbs) { return; }

    // Clone gallery thumbs into content
    const galleryThumbsClone = galleryThumbsWrap.cloneNode(true);
    galleryActivateThumbs.appendChild(galleryThumbsClone);
    const activateThumbs = galleryActivateThumbs.querySelectorAll('[data-product-custom-thumb]');

    activateThumbs.forEach(activateThumb => {
      activateThumb.addEventListener('click', handleActivateThumbClick);
    });

    function handleActivateThumbClick(event) {
      const thumb = event.currentTarget;
      const matchingGalleryThumb = galleryThumbsWrap.querySelector(`[data-thumb-index="${thumb.dataset.thumbIndex}"]`);
      content.classList.add('hidden');
      gallery.classList.remove('hide');
      matchingGalleryThumb.click();
      setTimeout(() => {
        document.addEventListener('click', handleClickOutsideClose);
      }, 100);

      handleArrowsNavigation();
    }

    function handleArrowsNavigation() {
      document.addEventListener('keydown', handleArrowsNavigationEvent);

      if (galleryControls && galleryMore) {
        galleryControlsWrapper.classList.remove('hide');
        galleryMore.classList.add('hide');

        galleryControls.forEach((control) => {
          control.addEventListener('click', handleControls);
        });
      }
    }

    function handleControls(event) {
      handleArrowsNavigationEvent({key: event.target.getAttribute('data-product-custom-gallery-control')});
    }

    function handleArrowsNavigationEvent(event) {
      let index = 0;
      galleryImages.forEach((image) => {
        if (!image.classList.contains('hide')) {
          index = parseInt(image.getAttribute('data-image-index'), 10);
        }
      });

      /* eslint-disable indent */
      switch (event.key) {
        case 'ArrowLeft':
          index -= 2;
          hideImages();
          if (index < 0) {
            galleryImages[galleryImages.length - 1].classList.remove('hide');
          } else {
            galleryImages[index].classList.remove('hide');
          }
          break;
        case 'ArrowRight':
          hideImages();
          if (index >= galleryImages.length) {
            galleryImages[0].classList.remove('hide');
          } else {
            galleryImages[index].classList.remove('hide');
          }
          break;
      }
      /* eslint-enable indent */

      function hideImages() {
        galleryImages.forEach((image) => {
          image.classList.add('hide');
        });
      }
    }

    function removeArrowsNavigation() {
      document.removeEventListener('keydown', handleArrowsNavigationEvent);
    }

    if (mobileGalleryOpenButton) {
      mobileGalleryOpenButton.addEventListener('click', handleMobileGalleryOpen);
    }

    function handleMobileGalleryOpen() {
      lastScrollPos = window.scrollY;
      content.classList.add('hidden');
      gallery.classList.remove('hide');
      galleryWrap.classList.add('mobile-open');
      galleryThumbs[0].click();
      trapFocus(gallery);
      handleArrowsNavigation();

      if (window.innerWidth < 750 && mobileGalleryOpenButton.getAttribute('data-product-custom-gallery-mobile-toggle') === 'quality') {
        siteBody.classList.add('drawer-active', 'popup-open');
      }
    }

    function handleClickOutsideClose(event) {
      const isOnGallery = event.path.find(element => typeof element.classList !== 'undefined' && element.classList.contains('product-custom-gallery'));
      if (!isOnGallery) {
        closePopup();
      }
    }

    galleryThumbs.forEach(galleryThumb => {
      galleryThumb.addEventListener('click', handleGalleryThumbClick);
    });

    function handleGalleryThumbClick(event) {
      const thumb = event.currentTarget;
      const matchingImage = galleryImageWrap.querySelector(`[data-image-index="${thumb.dataset.thumbIndex}"]`);

      galleryThumbs.forEach(galleryThumb => galleryThumb.classList.remove('active'));
      thumb.classList.add('active');
      galleryImages.forEach(galleryImage => galleryImage.classList.add('hide'));
      matchingImage.classList.remove('hide');
    }

    closeButton.addEventListener('click', () => {
      closePopup();
    });

    ctaButton.addEventListener('click', () => {
      closePopup();
      customizerButton.click();
    });

    function closePopup() {
      content.classList.remove('hidden');
      gallery.classList.add('hide');
      galleryWrap.classList.remove('mobile-open');
      removeTrapFocus(gallery);

      if (window.innerWidth < 750) {
        siteBody.classList.remove('drawer-active', 'popup-open');
      }

      document.removeEventListener('click', handleClickOutsideClose);
      removeArrowsNavigation();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  customProductGallery();
});

document.addEventListener('shopify:section:load', () => {
  customProductGallery();
});


// desc gallery 

function productDescriptionGalleryInit() {
  const productDescriptionGallery = document.querySelector('[data-product-description-gallery-images]');
  const productDescriptionThumbs = document.querySelector('[data-product-description-gallery-thumbs]');

  if (!productDescriptionGallery) { return; }

  const thumbsSwiper = new Swiper(productDescriptionThumbs, {
    spaceBetween: 12,
    slidesPerView: 4,
    preventClicks: false,
    preventClicksPropagation: false,
    noSwiping: true,
    threshold: 1000,
    direction: 'vertical',
    breakpoints: {
      1100: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  });

  new Swiper(productDescriptionGallery, {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      dynamicMainBullets: 6
    },
    navigation: {
      nextEl: '.product-description-gallery .swiper-button-next',
      prevEl: '.product-description-gallery .swiper-button-prev',
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });

  thumbsSwiper.update();
}

document.addEventListener('DOMContentLoaded', () => {
  productDescriptionGalleryInit();
});


// breadcrumbs 

 function setupDropdown(dropdown) {
  if (dropdown === null) { return; }

  const dropdownToggle = dropdown.querySelector('[data-dropdown-toggle]');
  const dropdownList = dropdown.querySelector('[data-dropdown-list]');
  const dropdownOptions = dropdown.querySelectorAll('[data-dropdown-option]');
  const dropdownOverlay = dropdown.querySelector('[data-dropdown-overlay]');

  dropdownToggle.addEventListener('keydown', handleDropdownToggle);
  dropdownToggle.addEventListener('click', handleDropdownToggle);

  dropdownList.addEventListener('keydown', handleKeyNavigation);

  dropdownOptions.forEach(option => {
    option.addEventListener('click', selectDropdownItem);
    option.addEventListener('keydown', selectDropdownItem);
  });

  dropdownOverlay.addEventListener('click', () => closeDropdown(dropdown));
}

// Toggle Dropdown
function handleDropdownToggle(event) {
  event.preventDefault();
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  if (event.code && (event.code !== 'Space' || event.code !== 'Enter')) { return; }

  const dropdown = event.target.closest('[data-dropdown]');
  const dropdownList = dropdown.querySelector('[data-dropdown-list]');

  if (dropdown.classList.contains('is-active')) {
    closeDropdown(dropdown);
  } else {
    // close open dropdowns
    dropdowns.forEach(dropdown => closeDropdown(dropdown));

    // open this one
    dropdown.classList.add('is-active');
    dropdown.setAttribute('aria-expanded', 'true');
    dropdownList.removeAttribute('hidden');

    setTimeout(() => {
      dropdownList.focus();
    }, 500);
  }
}

function closeDropdown(dropdown) {
  const dropdownList = dropdown.querySelector('[data-dropdown-list]');
  dropdown.classList.remove('is-active');
  dropdown.setAttribute('aria-expanded', 'false');
  dropdownList.setAttribute('hidden', '');
}

function handleKeyNavigation(event) {
  const key = event.keyCode;
  const dropdown = event.currentTarget.closest('[data-dropdown]');
  const options = dropdown.querySelectorAll('[data-dropdown-option]');
  const current = [...options].indexOf(dropdown.querySelector('[aria-activedescendant="true"]'));

  /* eslint-disable indent */
  let index = 0;
  switch (key) {
    case 13: // ENTER
      event.preventDefault();
      selectDropdownItem(event);
      break;
    case 32: // SPACE
      event.preventDefault();
      selectDropdownItem(event);
      break;
    case 27: // ESC
      event.preventDefault();
      closeDropdown(dropdown);
      break;
    case 35: // END
      event.preventDefault();
      index = options.length - 1;
      setActiveDescendant(index, current);
      break;
    case 36: // HOME
      event.preventDefault();
      index = options[0];
      setActiveDescendant(index, current);
      break;
    case 38: // UP
      event.preventDefault();
      index = current > 0 ? current - 1 : 0;
      setActiveDescendant(index, current);
      break;
    case 40: // DOWN
      event.preventDefault();
      index = current < options.length - 1 ? current + 1 : options.length - 1;
      setActiveDescendant(index, current);
      break;
  }
}

function selectDropdownItem(event) {
  const option = (event.code && event.code === 'Enter' || event.code === 'Space') ? event.target.querySelector('[aria-activedescendant]') : event.target;
  const optionText = option.querySelector('[data-dropdown-option-text]');
  const dropdown = option.closest('[data-dropdown]');
  const toggleText = dropdown.querySelector('[data-dropdown-toggle-text]');
  const options = dropdown.querySelectorAll('[data-dropdown-option]');
  const input = dropdown.querySelector('[data-dropdown-input]');
  const parentForm = input.closest('form');
  options.forEach(opt => opt.removeAttribute('aria-selected'));
  option.setAttribute('aria-selected', 'true');
  option.removeAttribute('aria-activedescendant');

  let buttonContent = '';
  if (optionText === null) {
    buttonContent = option.innerText;
  } else {
    buttonContent = optionText.innerHTML;
  }
  if (dropdown.dataset.preLabel) {
    buttonContent = `<strong>${dropdown.dataset.preLabel}:</strong> ${buttonContent}`;
  }

  toggleText.innerHTML = buttonContent;

  const optionValue = input.type === 'number' ? Number(option.dataset.value) : option.dataset.value;
  input.value = optionValue;

  const changeEvent = new Event('change');
  input.dispatchEvent(changeEvent);

  if (parentForm) {
    parentForm.dispatchEvent(changeEvent);
  }

  closeDropdown(dropdown);
}

function setActiveDescendant(index, current) {
  const dropdown = event.currentTarget;
  const options = dropdown.querySelectorAll('[data-dropdown-option]');

  let nextElement = options[index];
  if (typeof nextElement === 'undefined') { return; }

  if (nextElement.hasAttribute('aria-selected') && index > current) {
    nextElement = options[index + 1];
  } else if (nextElement.hasAttribute('aria-selected') && index < current) {
    nextElement = options[index - 1];
  }
  if (nextElement == null) {
    return;
  }

  options.forEach(option => option.removeAttribute('aria-activedescendant'));
  nextElement.setAttribute('aria-activedescendant', 'true');
  setTimeout(() => {
    nextElement.focus();
  }, 10);
}


// breadcrubs

function breadcrumbsCustom() {
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  dropdowns.forEach(dropdown => {
    setupDropdown(dropdown);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  breadcrumbsCustom();
});


// 

function realViewportHeight() {
  window.addEventListener('resize', updateViewportHeight);
  updateViewportHeight();

  function updateViewportHeight() {
    // get the real visible viewport height
    const vh = window.innerHeight;

    // set --viewport-height css custom property to the root of the document
    document.documentElement.style.setProperty('--viewport-height', `${vh}px`);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  realViewportHeight();
});

// popup init

 function popupInit() {
  const popupElements = document.querySelectorAll('[data-popup]');
  const popupTriggers = document.querySelectorAll('[data-popup-trigger]');
  const popupCloseButtons = document.querySelectorAll('[data-popup-close]');
  const siteOverlay = document.querySelector('[data-site-overlay]');
  const siteBody = document.querySelector('[data-site-body]');

  if (popupElements.length === 0) {
    popupTriggers.forEach(popupTrigger => {
      popupTrigger.classList.add('hide');
    });
    return;
  }

  popupTriggers.forEach((popupTrigger) => {
    popupTrigger.addEventListener('click', (event) => {
      event.preventDefault();
      openPopup(popupTrigger);
    });

    popupTrigger.addEventListener('keydown', (event) => {
      event.preventDefault();
      openPopup(popupTrigger);
    });
  });

  popupCloseButtons.forEach((popupCloseButton) => {
    popupCloseButton.addEventListener('click', (event) => {
      event.preventDefault();
      closePopup();
    });
  });

  siteOverlay.addEventListener('click', () => {
    closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if (event.keyCode !== 27) { return; }
    closePopup();
  });

  function openPopup(popupTrigger) {
    if (popupTrigger.hasAttribute('data-product-image') && window.innerWidth <= 1024) { return; }
    if (popupTrigger.hasAttribute('data-popup-trigger-mobile') && window.innerWidth >= 750) { return; }
    if (event.type === 'keydown' && event.keyCode !== 13) { return; }
    const currentScroll = window.scrollY;

    const popupTriggerHandle = popupTrigger.getAttribute('data-popup-handle');

    popupElements.forEach((popupElement) => {
      const popupHandle = popupElement.getAttribute('data-popup-handle');

      if (popupHandle === popupTriggerHandle) {
        siteBody.classList.add('drawer-active');
        siteOverlay.classList.add('active');
        popupElement.classList.add('active');
        trapFocus(popupElement);
        window.scroll(0, currentScroll);
      }
    });
  }

  function closePopup() {
    popupElements.forEach((popupElement) => {
      popupElement.classList.remove('active');
    });

    siteBody.classList.remove('drawer-active');
    siteOverlay.classList.remove('active');

    removeTrapFocus();
  }
}


// custom optiosn


function swatchesInit() {
  const moneyFormat = theme.moneyFormat;
  const siteHtml = document.querySelector('[data-site-html]');
  const siteBody = document.querySelector('[data-site-body]');
  const productCustomizer = document.querySelector('[data-product-customizer]');
  const productSelect = document.querySelector('[data-product-select]');
  const swatchElements = document.querySelectorAll('[data-swatch-element]');
  const sizeSwatches = document.querySelectorAll('[data-swatch-element="size"]');
  const typeSwatches = document.querySelectorAll('[data-swatch-element="type"]');
  const productNextButtons = document.querySelectorAll('[data-product-next-button]');
  const productContinueButtons = document.querySelectorAll('[data-product-continue-button]');
  const quoteContinueButtons = document.querySelectorAll('[data-product-quote-button]');
  const quantityInput = document.querySelector('[data-product-quantity]');
  const subtotalEl = document.querySelector('[data-product-subtotal]');
  const customQuantityMobileEl = document.querySelector('[data-custom-quantity-mobile]');
  const customQuantityMobileInput = document.querySelector('[data-custom-quantity-mobile-input]');
  const customQuantityEl = document.querySelector('[data-custom-quantity]');
  const customQuantityInput = document.querySelector('[data-custom-quantity-input]');
  const mobileSwatcheEls = document.querySelectorAll('[data-mobile-swatch-element]');
  const mobileSwatchSelects = document.querySelectorAll('[data-select-swatch]');
  const mobileViewAllOptionsButton = document.querySelector('[data-mobile-options-view-all-button]');
  const mobileViewPopularOptionsButton = document.querySelector('[data-mobile-options-view-popular-button]');
  const mobileViewOptionsAll = document.querySelector('[data-mobile-options-all]');
  const mobileViewOptionsBuyNow = document.querySelector('[data-mobile-options-buy-now]');
  const mobileStartButtonWrap = document.querySelector('[data-mobile-product-customizer-toggle-wrap]');
  const mobileStartButton = document.querySelector('[data-mobile-product-customizer-toggle]');
  const mobileCloseButton = document.querySelector('[data-mobile-customizer-close]');
  const mobileCustomizer = document.querySelector('[data-product-customizer-mobile]');
  const customizerOverlay = document.querySelector('[data-customizer-overlay]');

  const productJson = JSON.parse(document.querySelector('[data-product-json]').innerHTML);

  // Append unique line item id
  function uniqueId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    document.querySelector('#_id').value = result;
  }

  uniqueId(9);

  // Mobile customizer
  function mobileCustomizerInit() {
    if (!mobileCustomizer) { return; }

    const sizeSwatchesMobile = mobileCustomizer.querySelectorAll('[data-swatch-element="size"]');
    const typeSwatchesMobile = mobileCustomizer.querySelectorAll('[data-swatch-element="type"]');
    const swatchEls = mobileCustomizer.querySelectorAll('[data-swatch-element] input');
    const customQuantityToggle = mobileCustomizer.querySelector('[data-swatch-quantity-mobile] input');
    const customQuantityMobile = mobileCustomizer.querySelector('[data-custom-quantity-mobile]');
    const customQuantityInputMobile = mobileCustomizer.querySelector('[data-custom-quantity-input]');
    const minQuantityNotice = customQuantityMobile.querySelector('[data-min-quantity-notice]');
    const maxQuantityNotice = customQuantityMobile.querySelector('[data-max-quantity-notice]');
    const inputMin = parseInt(customQuantityInputMobile.getAttribute('min'), 10);
    const inputMax = parseInt(customQuantityInputMobile.getAttribute('max'), 10);
    const oneInchOption = [...sizeSwatchesMobile].find(swatch => swatch.dataset.value === '1in.');
    const firstSizeOption = (typeof oneInchOption === 'undefined') ? sizeSwatchesMobile[0] : oneInchOption;
    const firstSizeOptionLabel = firstSizeOption.querySelector('label');
    const hundredOption = [...typeSwatchesMobile].find(swatch => swatch.dataset.label === '100');
    const firstTypeOption = (typeof hundredOption === 'undefined') ? typeSwatchesMobile[1] : hundredOption;
    const firstTypeOptionLabel = firstTypeOption.querySelector('label');
    const quoteTrigger = document.querySelector('[data-quote-drawer-trigger-mobile]');
    const mobileCustomizerCtaWrapper = document.querySelector('[data-mobile-customizer-cta-wrapper]');
    const stickyQuoteTriggerWrapper = document.querySelector('[data-quote-sticky-cta-wrapper]');
    const stickyQuoteTrigger = stickyQuoteTriggerWrapper.querySelector('[data-quote-sticky-cta]');

    // initial state
    firstSizeOptionLabel.click();
    firstTypeOptionLabel.click();

    // update desktop customizer on mobile customizer change
    swatchEls.forEach((swatchEl) => {
      swatchEl.addEventListener('change', () => {
        const swatchParentEl = swatchEl.closest('[data-swatch-element]');
        const desktopEl = document.querySelector(`[data-value="${swatchParentEl.dataset.value}"] input`);

        if (desktopEl) {
          desktopEl.click();
        }

        customQuantityMobile.classList.toggle('hide', !customQuantityToggle.checked);
      });
    });

    // custom quantity change
    customQuantityInputMobile.addEventListener('input', () => {
      const customQuantityVal = parseInt(customQuantityInputMobile.value, 10);

      if (customQuantityVal > inputMax) {
        customQuantityInputMobile.value = inputMax;
        maxQuantityNotice.classList.remove('hide');
      } else {
        maxQuantityNotice.classList.add('hide');
      }

      if (customQuantityVal < inputMin || isNaN(customQuantityVal)) {
        minQuantityNotice.classList.remove('hide');
      } else {
        minQuantityNotice.classList.add('hide');
      }

      customQuantityInput.value = customQuantityInputMobile.value;
    });

    // custom quantity toggle
    customQuantityToggle.addEventListener('change', () => {
      customQuantityMobile.classList.toggle('hide', !customQuantityToggle.checked);
      customQuantityInputMobile.value = customQuantityInput.value;
    });

    // sticky cta
    stickyQuoteTrigger.addEventListener('click', () => {
      mobileCustomizer.scrollIntoView({
        behavior: 'smooth'
      });
    });

    // show/hide sticky cta
    function scrollObserverCallback(entries) {
      entries.forEach(entry => {
        const isScrolledEnough = entry.isIntersecting || (entry.boundingClientRect.top <= window.innerHeight - 100);
        stickyQuoteTriggerWrapper.classList.toggle('hidden', isScrolledEnough);
        // mobileCustomizerCtaWrapper.classList.toggle('sticky', isScrolledEnough);
      });
    }

    const drawerScrollObserver = new IntersectionObserver(scrollObserverCallback, {
      rootMargin: '0px 0px -20px 0px',
      threshold: 1,
      delay: 0,
    });

    drawerScrollObserver.observe(mobileCustomizerCtaWrapper);
  }
  mobileCustomizerInit();

  // Select inital size option
  const oneInchOption = [...sizeSwatches].find(swatch => swatch.dataset.value === '1in.');
  const firstSizeOption = (typeof oneInchOption === 'undefined') ? sizeSwatches[0] : oneInchOption;
  const firstSizeOptionLabel = firstSizeOption.querySelector('label');
  firstSizeOptionLabel.click();

  // Select inital quantity option
  const hundredOption = [...typeSwatches].find(swatch => swatch.dataset.label === '100');
  const firstTypeOption = (typeof hundredOption === 'undefined') ? typeSwatches[1] : hundredOption;
  const firstTypeOptionLabel = firstTypeOption.querySelector('label');
  firstTypeOptionLabel.click();

  /* ----- Upadte prices and everything else ---- */
  function updatePrices(event = null, quantityTier = null) {
    const selectedSizeInput = document.querySelector('[data-swatch-element="size"] input:checked');
    const selectedTypeInput = document.querySelector('[data-swatch-element="type"] input:checked');
    const selectedTypeEl = selectedTypeInput.closest('[data-swatch-element]');

    // Get option values
    let sizeOptionValue = selectedSizeInput.value;
    let typeOptionValue = selectedTypeInput.value;
    if (selectedTypeInput.value === 'custom-quantity' && quantityTier !== null) {
      sizeOptionValue += ` ${quantityTier}`;
      typeOptionValue = `Regular ${quantityTier}`;
      quantityInput.setAttribute('data-quantity-tier', quantityTier.replace('+', ''));
    } else if (selectedTypeInput.value.includes('+')) {
      const selectedTypeInputParts = selectedTypeInput.value.split(' ');
      sizeOptionValue += ` ${selectedTypeInputParts[1]}`;
      quantityInput.setAttribute('data-quantity-tier', parseFloat(selectedTypeEl.dataset.label));
    } else {
      quantityInput.setAttribute('data-quantity-tier', 1);
    }

    // Update quantity
    if (selectedTypeInput.value !== 'custom-quantity') {
      quantityInput.value = parseFloat(selectedTypeEl.dataset.label);

      // Re-enable continue buttons
      productNextButtons.forEach(productNextButton => {
        productNextButton.classList.remove('disabled');
        productNextButton.removeAttribute('disabled');
      });
    }

    // Update prices
    typeSwatches.forEach(typeSwatch => {
      const retailPriceEl = typeSwatch.querySelector('[data-swatch-price]');
      const wholesalePriceEl = typeSwatch.querySelector('[data-swatch-price-wholesale]');
      const typeSwatchValueParts = typeSwatch.dataset.value.split(' ');
      const typeSwatchValue = (typeSwatchValueParts.length > 1) ? ` ${typeSwatchValueParts[1]}` : '';
      const currentSizeValue = `${selectedSizeInput.value}${typeSwatchValue}`;

      // Update retail price
      let newPrice = 0;
      const matchingVariant = productJson.variants.filter(variant => {
        return (variant.option1 === currentSizeValue && variant.option2 === typeSwatch.dataset.value);
      });
      if (matchingVariant.length > 0) {
        const retailPrice = Shopify.formatMoney(matchingVariant[0].price, moneyFormat);
        retailPriceEl.textContent = retailPrice;
        newPrice = retailPrice;
      }

      // Update wholesale price
      if (wholesalePriceEl) {
        const tagPrefix = `wholesale-${typeSwatch.dataset.label}`;
        const matchingTag = productJson.tags.find(tag => tag.includes(tagPrefix));
        if (matchingTag && matchingVariant.length > 0) {
          const tagParts = matchingTag.split('-');
          const discountAmount = tagParts[2];
          const wholesalePrice = Math.round(parseFloat(matchingVariant[0].price) * parseFloat(discountAmount), 2);
          const wholesalePriceFormatted = Shopify.formatMoney(wholesalePrice, moneyFormat);
          wholesalePriceEl.textContent = wholesalePriceFormatted;
          newPrice = wholesalePriceFormatted;
        }
      }

      // Update matching mobile quantity price
      const matchingMobileSwatchEl = document.querySelector(`[data-mobile-swatch-element="type"][data-value="${typeSwatch.dataset.value}"]`);
      if (matchingMobileSwatchEl !== null) {
        const matchingMobileSwatchPriceEl = matchingMobileSwatchEl.querySelector('[data-swatch-price]');
        matchingMobileSwatchPriceEl.textContent = `${newPrice} ea`;
      }

      // Update matching mobile select option label
      const matchingMobileQuantityOption = document.querySelector(`[data-select-swatch] option[value="${typeSwatch.dataset.value}"]`);
      if (matchingMobileQuantityOption !== null && typeSwatch.dataset.value !== 'Custom Quantity') {
        matchingMobileQuantityOption.textContent = `${matchingMobileQuantityOption.dataset.label} - ${newPrice} ea`;
      }
    });

    // Select product option
    const optionSelectOption = productSelect.querySelector(`option[data-option-0="${sizeOptionValue}"][data-option-1="${typeOptionValue}"]`);
    if (optionSelectOption !== null) {
      productSelect.value = optionSelectOption.value;
    }

    // Update subtotal
    let subtotalValue = parseFloat(optionSelectOption.dataset.variantPrice) * parseFloat(quantityInput.value);

    // Calculate wholesale subtotal if wolesale product
    if (productCustomizer.hasAttribute('data-product-customizer-wholesale') && typeOptionValue !== 'Sample') {
      const tagPrefixAmount = (quantityTier) ? quantityTier.replace('+', '') : selectedTypeEl.dataset.label;
      const tagPrefix = `wholesale-${tagPrefixAmount}`;
      const matchingTag = productJson.tags.find(tag => tag.includes(tagPrefix));
      const tagParts = matchingTag.split('-');
      const discountAmount = tagParts[2];
      subtotalValue *= discountAmount;
    }
    subtotalEl.textContent = Shopify.formatMoney(subtotalValue, moneyFormat);
  }

  // Mobile - swatch selects
  mobileSwatchSelects.forEach(select => {
    const swatchType = select.dataset.selectSwatch;

    select.addEventListener('change', (event) => {
      // Activate custom quantity field
      if (event.target.value === 'Custom Quantity') {
        customQuantityMobileEl.classList.remove('hide');
      } else {
        customQuantityMobileEl.classList.add('hide');
      }
      const matchingRadioSwatchInput = document.querySelector(`[data-swatch-element="${swatchType}"][data-value="${event.target.value}"] input`);
      matchingRadioSwatchInput.checked = true;
      matchingRadioSwatchInput.dispatchEvent(new Event('change'));
      setTimeout(() => {
        customQuantityMobileInput.focus();
      }, 20);
    });
  });

  // Desktop - size click handler
  sizeSwatches.forEach(sizeSwatch => {
    const swacthInput = sizeSwatch.querySelector('input');
    swacthInput.addEventListener('change', () => {
      const selectedTypeInput = document.querySelector('[data-swatch-element="type"] input:checked');
      if (selectedTypeInput.value === 'custom-quantity') {
        customQuantityInput.dispatchEvent(new Event('change'));
      } else {
        updatePrices();
      }
    });
  });

  // Desktop - handle "type" swatch click
  typeSwatches.forEach(typeSwatch => {
    const input = typeSwatch.querySelector('input');
    input.addEventListener('change', handleTypeChange);
  });

  function handleTypeChange(event) {
    const input = event.currentTarget;
    const sampleNotice = document.querySelector('[data-sample-notice]');

    // Custom quantity
    if (input.value === 'custom-quantity') {
      quantityInput.value = 1;
      customQuantityEl.classList.remove('hide');
      customQuantityInput.focus();
      customQuantityInput.value = 100;
      customQuantityInput.dispatchEvent(new Event('input'));
    } else {
      customQuantityEl.classList.add('hide');
      updatePrices();
    }

    // Sample
    if (!sampleNotice) { return; }
    if (input.value === 'Sample') {
      sampleNotice.classList.remove('hide');
    } else {
      sampleNotice.classList.add('hide');
    }
  }

  // Custom quantity inputs
  customQuantityInput.addEventListener('input', handleCustomQuantityInput);
  customQuantityMobileInput.addEventListener('input', handleCustomQuantityInput);
  customQuantityInput.addEventListener('change', handleCustomQuantityInput);
  customQuantityMobileInput.addEventListener('change', handleCustomQuantityInput);

  function handleCustomQuantityInput(event) {
    const customInput = event.currentTarget;
    const inputMin = parseInt(customInput.getAttribute('min'), 10);
    const inputMax = parseInt(customInput.getAttribute('max'), 10);
    const minQuantityNotice = customInput.parentElement.querySelector('[data-min-quantity-notice]');
    const maxQuantityNotice = customInput.parentElement.querySelector('[data-max-quantity-notice]');
    const customQuantityVal = parseInt(customInput.value, 10);
    const quantityTiers = [50, 100, 250, 500, 1000, 2500, 5000];
    let quantityTier = null;

    if (customQuantityVal > inputMax) {
      customInput.value = inputMax;
      maxQuantityNotice.classList.remove('hide');
    } else {
      maxQuantityNotice.classList.add('hide');
    }

    // Update primary quantity field
    quantityInput.value = customInput.value;

    // Enable / disable continue button
    if (customQuantityVal < inputMin || isNaN(customQuantityVal)) {
      productNextButtons.forEach(productNextButton => {
        productNextButton.classList.add('disabled');
        productNextButton.setAttribute('disabled', true);
      });
      minQuantityNotice.classList.remove('hide');
      subtotalEl.textContent = '';
    } else {
      productNextButtons.forEach(productNextButton => {
        productNextButton.classList.remove('disabled');
        productNextButton.removeAttribute('disabled');
      });
      minQuantityNotice.classList.add('hide');

      // Find quantity tier
      quantityTier = quantityTiers.find((tier, index) => {
        if (quantityTiers[index + 1]) {
          return (customQuantityVal >= tier && customQuantityVal < quantityTiers[index + 1]);
        } else {
          return (customQuantityVal >= tier);
        }
      });

      // Update prices
      quantityTier = `${quantityTier}+`;
      updatePrices(null, quantityTier);
    }
  }

  // Continue buttons
  productContinueButtons.forEach(productContinueButton => {
    productContinueButton.addEventListener('click', handleProductContinue);
  });

  // Quote buttons
  quoteContinueButtons.forEach(quoteContinueButton => {
    quoteContinueButton.addEventListener('click', handleProductContinue);
  });

  function handleProductContinue(event) {
    event.preventDefault();
    const selectedSizeInput = document.querySelector('[data-swatch-element="size"] input:checked');
    const sampleSwatch = document.querySelector('[data-swatch-element="type"][data-value="Sample"] input');
    const customQauntitySwatch = document.querySelector('[data-swatch-quantity] input');
    const quantityTier = quantityInput.getAttribute('data-quantity-tier');

    // get variant id
    const variantId = productSelect.value;
    // get custom quantity
    const customQuantity = customQuantityInput.value;
    // get size
    const size = selectedSizeInput.value;

    // get prodcut title, url
    const productTitle = productJson.title.replace(new RegExp(' ', 'g'), '-');
    const productUrl = `/products/${productJson.handle}`;

    let quantity = 50;
    if (sampleSwatch && sampleSwatch.checked === true) {
      // Sample product
      quantity = 'Sample';
    } else if (customQauntitySwatch.checked === true) {
      quantity = `c_${customQuantity}`;
    } else {
      quantity = quantityInput.value;
    }

    const baseUrl = event.currentTarget.hasAttribute('data-product-quote-button') ? '/pages/request-a-quote' : '/pages/upload-artwork';
    const url = `${baseUrl}?variant_id=${variantId}&size=${size}&quantity=${quantity}&product_title=${productTitle}&product_url=${productUrl}&quantity_tier=${quantityTier}`;

    window.open(url, '_self', '', true);
  }

  // Mobile view all options
  mobileViewAllOptionsButton.addEventListener('click', (event) => {
    event.preventDefault();
    mobileViewOptionsBuyNow.classList.add('hide');
    mobileViewOptionsAll.classList.remove('hide');
  });

  // Create mobile popular swatches
  const popularSwatchParentEls = document.querySelectorAll('[data-mobile-popular-swatches]');
  popularSwatchParentEls.forEach(popularSwatchParentEl => {
    const swatchType = popularSwatchParentEl.getAttribute('data-mobile-popular-swatches');
    const mobileswatchTemplate = popularSwatchParentEl.querySelector('[data-mobile-swatch-template]');
    const mobileSwatchEl = mobileswatchTemplate.content.querySelector('[data-mobile-swatch-element]');
    const swatches = swatchType === 'size' ? sizeSwatches : typeSwatches;
    const swatchSelect = document.querySelector(`[data-select-swatch="${swatchType}"]`);

    let swatchTotal = 0;
    swatches.forEach(swatch => {
      if (swatchTotal > 2 || swatch.dataset.label === '1') { return; }

      const swatchInput = swatch.querySelector('input');
      const newSwatch = document.importNode(mobileSwatchEl, true);
      const newSwatchInput = newSwatch.querySelector('input');
      const newSwatchLabel = newSwatch.querySelector('label');
      const newSwatchLabelPrice = newSwatch.querySelector('[data-swatch-price]');
      const newSwatchLabelText = newSwatch.querySelector('[data-mobile-swatch-element-label]');

      newSwatch.setAttribute('data-label', swatch.dataset.label);
      newSwatch.setAttribute('data-value', swatch.dataset.value);
      newSwatchInput.setAttribute('id', `${swatchInput.id}-mobile`);
      newSwatchLabel.setAttribute('for', `${swatchInput.id}-mobile`);
      newSwatchInput.value = swatchInput.value;
      if (swatchType === 'size') {
        newSwatchLabelText.innerHTML = swatch.dataset.value.replace('in.', '&rdquo;');
      }

      if (swatchType === 'type') {
        const swatchPrice = swatch.querySelector('[data-swatch-price]');
        newSwatchLabelPrice.textContent = swatchPrice.textContent;
        newSwatchLabelText.innerHTML = swatch.dataset.label;
      }

      newSwatchInput.addEventListener('change', () => {
        swatchSelect.value = newSwatchInput.value;
        swatchSelect.dispatchEvent(new Event('change'));
      });

      popularSwatchParentEl.appendChild(newSwatch);
      swatchTotal++;
    });
  });

  // Mobile view popular options
  mobileViewPopularOptionsButton.addEventListener('click', (event) => {
    event.preventDefault();
    mobileViewOptionsBuyNow.classList.remove('hide');
    mobileViewOptionsAll.classList.add('hide');

    // Select first 2 options
    const firstSizeSwatch = document.querySelector('[data-mobile-swatch-element="size"] label');
    const firstTypeSwatch = document.querySelector('[data-mobile-swatch-element="type"] label');
    firstSizeSwatch.click();
    firstTypeSwatch.click();
  });

  // Mobile - Open customizer
  mobileStartButton.addEventListener('click', handleMobileCusomizerOpen);

  function handleMobileCusomizerOpen() {
    const smileContainer = document.querySelector('#smile-ui-container');
    productCustomizer.classList.add('active');
    customizerOverlay.classList.add('active');
    mobileStartButtonWrap.classList.add('hide');
    trapFocus(productCustomizer);

    if (smileContainer) {
      smileContainer.classList.add('hide');
    }

    // Select first 2 options
    const firstSizeLabel = document.querySelector('[data-mobile-swatch-element="size"] label');
    const firstQuantityLabel = document.querySelector('[data-mobile-swatch-element="type"] label');
    firstSizeLabel.click();
    firstQuantityLabel.click();

    window.scrollTo({left: 0, top: window.scrollY + 100, behavior: 'smooth'});
  }

  // Mobile - Close customizer
  mobileCloseButton.addEventListener('click', handleMobileCusomizerClose);
  customizerOverlay.addEventListener('click', handleMobileCusomizerClose);

  function handleMobileCusomizerClose() {
    const smileContainer = document.querySelector('#smile-ui-container');
    event.preventDefault();
    productCustomizer.classList.remove('active');
    customizerOverlay.classList.remove('active');
    mobileStartButtonWrap.classList.remove('hide');
    removeTrapFocus(productCustomizer);

    if (smileContainer) {
      smileContainer.classList.remove('hide');
    }
  }

  // Update prices on load
  updatePrices();
}

document.addEventListener('DOMContentLoaded', () => {
  swatchesInit();
  popupInit();
});


// custom inspiration

function initProductCustomInspiration() {
  const getInspired = document.querySelector('[data-get-inspired]');
  const getInspiredScroll = document.querySelector('[data-get-inspired-scroll]');
  const getInspiredBlocks = document.querySelectorAll('[data-get-inspired-block]');

  if (!getInspiredBlocks) { return; }

  function parallax() {
    const sectionRect = getInspired.getBoundingClientRect();

    if (sectionRect.y > window.innerHeight) { return; }

    const scrollamount = (sectionRect.y * -1 + window.innerHeight);
    const scrollPercentage = scrollamount / (sectionRect.height + window.innerHeight);

    for (let i = 0; i < getInspiredBlocks.length; i++) {
      const block = getInspiredBlocks[i];
      const blockParallaxVal = block.getAttribute('data-get-inspired-block-parallax-desktop');
      const translateValue = -50 + (scrollPercentage * 100 * blockParallaxVal);
      block.style.transform = `translate3d(0, ${translateValue}px, 0)`;
    }
  }

  let ticking = false;
  function parallaxScrollHandler() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        parallax();
        ticking = false;
      });
      ticking = true;
    }
  }

  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        window.addEventListener('scroll', parallaxScrollHandler);
      } else {
        window.removeEventListener('scroll', parallaxScrollHandler);
      }
    });
  }, {
    threshold: 0,
  });

  sectionObserver.observe(getInspiredScroll);

  const blockObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('active');
        }, 250 * index);
      }
    });
  }, {
    threshold: 0.35,
  });

  getInspiredBlocks.forEach(block => {
    blockObserver.observe(block);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductCustomInspiration();
});

document.addEventListener('shopify:section:load', () => {
  initProductCustomInspiration();
});


// custom faq

function initFaqCategories() {
  const toggles = document.querySelectorAll('[data-faq-category-toggle]');
  const groups = document.querySelectorAll('[data-faq-category]');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const targetGroup = document.querySelector(`[data-faq-category="${toggle.getAttribute('data-faq-category-toggle')}"]`);
      if (!targetGroup) { return; }

      groups.forEach(oldGroup => oldGroup.classList.add('hide'));
      targetGroup.classList.remove('hide');
      toggles.forEach(oldToggle => oldToggle.classList.remove('active'));
      toggle.classList.add('active');
    });
  });
}

function initFaqGroup(group) {
  const toggle = group.querySelector('[data-question]');
  const content = group.querySelector('[data-answer]');
  if (!toggle || !content) { return; }

  toggle.addEventListener('click', () => {
    if (toggle.hasAttribute('data-open')) {
      content.style.maxHeight = null;
      toggle.removeAttribute('data-open');
    } else {
      content.style.maxHeight = `${content.scrollHeight}px`;
      toggle.setAttribute('data-open', '');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initFaqCategories();
  document.querySelectorAll('[data-faq-group]').forEach((group) => {
    initFaqGroup(group);
  });
});




document.addEventListener('DOMContentLoaded', () => {
  accordionsInit();
});
